// extracted by mini-css-extract-plugin
export default {"item":"GBhrkVeVI_pPe6kVTWQG"};